import * as React from "react";
const SvgLikeList = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M7 13h4m-5.333-2.333h6.666M4.333 2h9.334C14.403 2 15 2.663 15 3.481v10.37c0 .82-.597 1.482-1.333 1.482H4.333C3.597 15.333 3 14.67 3 13.852V3.482C3 2.662 3.597 2 4.333 2m4.665 2.808c-.466-.52-1.244-.66-1.829-.184-.584.476-.666 1.271-.207 1.834.459.562 2.036 1.875 2.036 1.875s1.578-1.313 2.037-1.875a1.27 1.27 0 0 0-.208-1.834c-.594-.47-1.362-.335-1.829.184"
    />
  </svg>
);
export default SvgLikeList;
